import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import ExistingAccountConflictModal from './ExistingAccountConflictModal';
import PostMergeCloudPicker from './PostMergeCloudPicker';
import RequireAccountModal from './RequireAccountModal';
import CassetteCloudPaywallModal from './CassetteCloudPaywallModal';

const AnonymousAuthModals: React.FC = () => {
  const {
    accountConflict,
    confirmExistingAccountSignIn,
    dismissAccountConflict,
    conflictBusy,
    needsCloudChoice,
    completeCloudChoice,
    linkStorage,
    linkWithGoogle,
    linkWithApple,
    eligibleForCassetteProjectStorage,
  } = useAuth();

  const [requireAccountOpen, setRequireAccountOpen] = useState(false);
  const [cassettePaywallOpen, setCassettePaywallOpen] = useState(false);

  useEffect(() => {
    const onAccountLinkRequired = () => setRequireAccountOpen(true);
    window.addEventListener('account-link-required', onAccountLinkRequired);
    return () => window.removeEventListener('account-link-required', onAccountLinkRequired);
  }, []);

  return (
    <>
      <ExistingAccountConflictModal
        isOpen={!!accountConflict?.open}
        method={accountConflict?.method ?? 'google'}
        hasStorage={accountConflict?.hasStorage}
        onConfirm={confirmExistingAccountSignIn}
        onCancel={dismissAccountConflict}
        busy={conflictBusy}
      />
      <PostMergeCloudPicker
        isOpen={needsCloudChoice}
        eligibleForCassetteProjectStorage={eligibleForCassetteProjectStorage}
        onChooseCassetteCloud={completeCloudChoice}
        onChooseExternal={async (provider) => {
          await linkStorage(provider);
        }}
        onDismiss={completeCloudChoice}
        onCassetteCloudUpsell={() => setCassettePaywallOpen(true)}
      />
      <CassetteCloudPaywallModal
        isOpen={cassettePaywallOpen}
        onClose={() => setCassettePaywallOpen(false)}
      />
      <RequireAccountModal
        isOpen={requireAccountOpen}
        onClose={() => setRequireAccountOpen(false)}
        onLinkGoogle={() => {
          setRequireAccountOpen(false);
          void linkWithGoogle();
        }}
        onLinkApple={() => {
          setRequireAccountOpen(false);
          void linkWithApple();
        }}
      />
    </>
  );
};

export default AnonymousAuthModals;
